import React,{useState} from 'react'
import "./Testimonial.css"
import Testimonial from './TestimonialServer'
import { Swiper, SwiperSlide } from "swiper/react";
import { VscQuote } from "react-icons/vsc";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";


function Test() {
 const [testimonial]=useState(Testimonial)

  return (
    <div className='container-fluid'>


 <Swiper
          slidesPerView={1}
          spaceBetween={30}
          slidesPerGroup={1}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {testimonial.map(item=>{
              const{id,description,name,title,image }=item;
              return (
                <SwiperSlide key={id}>
                  <div className="testimonial-position">
                    <div className="testimonial-image">
                      <img src={image} alt={name} />
                    </div>
                    <div className="testimonial-details">
                      <h3>
                        <VscQuote />
                      </h3>
                      <p> {description}</p>
                      <h4>{name}</h4>
                      <span>{title} </span>
                    </div>
                  
                  </div>
                </SwiperSlide>
              );
        })}
        </Swiper>

    
    </div>
  )
}

export default Test
